import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { EditableFormComponent } from 'src/app/components/editable-form/editable-form.component';
import { InputButtonComponent } from 'src/app/components/input/input-button/input-button.component';
import { InputSearchComponent } from 'src/app/components/input/input-search/input-search.component';
import { DocumentoDaoService } from 'src/app/dao/documento-dao-service';
import { TipoDocumentoDaoService } from 'src/app/dao/tipo-documento-dao.service';
import { TipoProcessoDaoService } from 'src/app/dao/tipo-processo-dao.service';
import { DadosSei, ListenerAllPagesService, SeiKeys } from 'src/app/listeners/listener-all-pages.service';
import { Documento } from 'src/app/models/documento.model';
import { PageFrameBase } from 'src/app/modules/base/page-frame-base';

@Component({
  selector: 'documentos-adicionar-sei',
  templateUrl: './documentos-adicionar-sei.component.html',
  styleUrls: ['./documentos-adicionar-sei.component.scss']
})
export class DocumentosAdicionarSeiComponent extends PageFrameBase {
  @ViewChild(EditableFormComponent, { static: false }) public editableForm?: EditableFormComponent;
  @ViewChild('numeroProcesso', { static: false }) public numeroProcesso?: InputButtonComponent;
  @ViewChild('tipoProcesso', { static: false }) public tipoProcesso?: InputSearchComponent;
  @ViewChild('tipoDocumento', { static: false }) public tipoDocumento?: InputSearchComponent;

  public tipoDocumentoDao: TipoDocumentoDaoService;
  public documentoDao: DocumentoDaoService;
  public tipoProcessoDao: TipoProcessoDaoService;
  public allPages: ListenerAllPagesService;
  public documento?: Documento;
  public sei?: SeiKeys;
  public processo?: DadosSei;

  constructor(public injector: Injector) {
    super(injector);
    this.tipoDocumentoDao = injector.get<TipoDocumentoDaoService>(TipoDocumentoDaoService);
    this.tipoProcessoDao = injector.get<TipoProcessoDaoService>(TipoProcessoDaoService);
    this.documentoDao = injector.get<DocumentoDaoService>(DocumentoDaoService);
    this.allPages = injector.get<ListenerAllPagesService>(ListenerAllPagesService);
    this.modalWidth = 400;
    this.form = this.fh.FormBuilder({
      numero_processo: {default: ""},
      tipo_processo_id: {default: ""},
      tipo_documento_id: {default: ""}
    }, this.cdRef, this.validate);
  }

  ngOnInit(): void {
    super.ngOnInit();
    (async () => {
      this.loading = true;
      try {
        let documentoId = this.metadata?.documento?.id || this.urlParams?.get("documentoId");
        this.documento = this.metadata?.documento || await this.dao!.getById(documentoId!);
        this.sei = this.metadata?.seiKeys || await this.allPages.getProcessoKeys();
        await this.loadData(this.documento!, this.form!);
      } finally {
        this.loading = false;
      }
    }).bind(this)();
  }

  public async loadData(entity: Documento, form: FormGroup) {
    form.patchValue({ numero_processo: this.sei?.numero_processo });
    await this.onNumeroProcessoClick(new Event("Click"));
  }

  public validate = (control: AbstractControl, controlName: string) => {
    let result = null;
    if (["numero_processo", "tipo_documento_id"].includes(controlName) && !control.value?.length) {
      result = "Obrigatório";
    } else if (controlName == "numero_processo" && control.value != this.processo?.processo?.numero_processo) {
      result = "Processo não encontrado";
    }
    return result;
  }

  public async onAdicionarClick() {
    this.form?.markAllAsTouched();
    if(this.form?.valid) {
      this.submitting = true;
      try {
        this.documento!.tipo_documento_id = this.form!.controls.tipo_documento_id.value;
        this.documento!.tipo_documento = this.tipoDocumento!.selectedEntity;
        await this.allPages.addDocumento(this.documento!, this.processo);
        this.close();
      } catch (error: any) {
        this.error(error.message ? error.message : error);
      } finally {
        this.submitting = false;
      }
    }
  }

  public async onNumeroProcessoClick(event: Event) {
    const processoRequisicao = this.form?.controls.numero_processo?.value;
    if(processoRequisicao?.length) {
      this.numeroProcesso!.loading = true;
      try {
        this.processo = await this.allPages.getDadosProcesso(processoRequisicao);
        if(this.processo) {
          if(this.processo.processo?.tipo_processo_codigo?.length || this.processo.processo?.tipo_processo_nome?.length) {
            const tipoProcesso = await this.tipoProcessoDao.consultarIncluir(this.processo.processo?.tipo_processo_codigo, this.processo.processo?.tipo_processo_nome); 
            if(tipoProcesso) this.tipoProcesso?.loadSearch(tipoProcesso);
          }
        } else {
          this.processo = undefined;
          throw new Error("Processo não encontrado");
        }
      } catch (error) {
        this.dialog.alert("Error", "Impossível encontrar o processo informado.")
      } finally {
        this.form!.controls.numero_processo.updateValueAndValidity();
        this.numeroProcesso!.loading = false;
      }
    }
  }

}

